module.exports = __webpack_public_path__ + "img/SHB.487d9a42.svg";